var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIconFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.995117 13.2071V15.5C0.995117 15.7761 1.21897 16 1.49512 16H3.79289C3.9255 16 4.05268 15.9473 4.14645 15.8535L13.5942 6.40581L10.5935 3.40517L1.14163 12.8535C1.04782 12.9473 0.995117 13.0745 0.995117 13.2071ZM11.8322 2.16692L14.8327 5.16733L16.2929 3.70709C16.6834 3.31656 16.6834 2.6834 16.2929 2.29287L14.707 0.706956C14.3165 0.316483 13.6834 0.316424 13.2929 0.706823L11.8322 2.16692Z",
    fill: "#2653F1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconFilled);
export default __webpack_public_path__ + "static/media/editIconFilled.f0d0a74c64484c81c6d14934853a9957.svg";
export { ForwardRef as ReactComponent };